import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { resolveConfluenceDraftSiblingParent } from '@atlassian/conversation-assistant-utils/resolveConfluenceDraftSiblingParent';

/**
 * Resolves the parent to use when contextual Remix finalizes a diagram.
 * Draft pages cannot have children, so diagrams generated from a draft are
 * finalized beside it under the draft's direct parent.
 */
export const resolveFinalizeParentId = async (
	currentPageId: string | undefined,
): Promise<string | undefined> => {
	if (!currentPageId) {
		return undefined;
	}

	const isFinalizeDiagramSiblingDraftKillswitchOn =
		// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
		FeatureGates.getExperimentValue<boolean>(
			'confluence_maui_finalize_diagram_sibling_draft',
			'value',
			false,
		);
	if (isFinalizeDiagramSiblingDraftKillswitchOn) {
		return currentPageId;
	}

	const draftSiblingParentId = await resolveConfluenceDraftSiblingParent(currentPageId, {
		distinguishRootDraft: true,
	});

	return draftSiblingParentId === null ? undefined : (draftSiblingParentId ?? currentPageId);
};
